import { isStudioYouTubeId } from "./studioVideoId";
import { YT_PLAYING } from "./videoFocusState";

export function isPlayerPlaying(playerState) {
  return playerState === YT_PLAYING;
}

export function nextVideoChangeSerial(serial, selectedId, currentVideoId) {
  const current = Number(serial) || 0;
  if (!selectedId || selectedId === currentVideoId) return current;
  return current + 1;
}

export function nextYoutubeLoadSerial(serial, suppliedId, currentVideoId) {
  const current = Number(serial) || 0;
  if (!isStudioYouTubeId(suppliedId) || suppliedId === currentVideoId) return current;
  return current + 1;
}

export function nextPlaylistChangeSerial(serial, selectedId, currentPlaylistId) {
  const current = Number(serial) || 0;
  if (!selectedId || selectedId === currentPlaylistId) return current;
  return current + 1;
}

export function sourceVideoId(video) {
  return video?.snippet?.resourceId?.videoId || "";
}

export function sourcesHasAlternativeVideo(videos, videoId) {
  return (Array.isArray(videos) ? videos : []).some((video) => {
    const id = sourceVideoId(video);
    return !!id && id !== videoId;
  });
}

export function playlistGuideSnapshot({
  loading = false,
  error = "",
  playlists = [],
  activePlaylistId = null,
} = {}) {
  const rows = Array.isArray(playlists) ? playlists : [];
  const ids = rows.map((row) => row?.playlistId).filter(Boolean);
  let phase = "ready";
  if (loading && rows.length === 0) phase = "loading";
  else if (error && rows.length === 0) phase = "error";
  return {
    phase,
    hasAlternativePlaylist: phase === "ready" && ids.some((id) => id !== activePlaylistId),
    count: rows.length,
  };
}
